// src/configure-language.ts (or .js)

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const files = {
  ...import.meta.glob('../**/(asset|assets)/i18n/*.{en,mn}.json', {
    eager: true,
    import: 'default',
  }),
  ...import.meta.glob('@nes/**/i18n/*.{en,mn}.json', {
    eager: true,
    import: 'default',
  }),
  ...import.meta.glob('@nes/**/(asset|assets)/i18n/*.{en,mn}.json', {
    eager: true,
    import: 'default',
  }),
};

// if (import.meta.env?.DEV) {
//   console.log('[i18n] discovered files:', Object.keys(files));
// }

type Dict = Record<string, any>;
const resources: Record<'en' | 'mn', Record<string, Dict>> = { en: {}, mn: {} };

function deepMerge(target: Dict, source: Dict) {
  for (const k of Object.keys(source)) {
    const sv = source[k];
    const tv = target[k];
    if (sv && typeof sv === 'object' && !Array.isArray(sv)) {
      target[k] = deepMerge(tv ?? {}, sv);
    } else {
      target[k] = sv;
    }
  }
  return target;
}

Object.entries(files).forEach(([path, data]) => {
  const m = path.match(/(?:^|\/)(asset|assets)\/i18n\/(.+?)\.(en|mn)\.json$/);
  if (!m) return;
  const namespace = m[2];
  const lng = m[3] as 'en' | 'mn';
  if (!resources[lng][namespace]) resources[lng][namespace] = {};
  deepMerge(resources[lng][namespace], data as any);
});

const ns = Array.from(
  new Set([
    ...Object.keys(resources.en || {}),
    ...Object.keys(resources.mn || {}),
  ])
);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'mn',
    fallbackLng: 'en',
    ns,
    defaultNS: ns.includes('common') ? 'common' : ns[0],
    interpolation: { escapeValue: false },
    supportedLngs: ['en', 'mn'],
    // debug: import.meta.env?.MODE !== 'production',
    debug: false,
  });

export default i18n;
